if (!customElements.get('selling-plan-selector')) {
  class SellingPlanSelector extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.addEventListener('coco-shuffle:product-updated', (e) => {
        this.productSwap(e.detail);
      });

      this.syncFormInputs();
      this.addEventListener('change', () => {
        this.syncFormInputs();
      });
      
      document.querySelectorAll('[data-bmsm]').forEach((bmsm) => {
        bmsm.addEventListener('change', () => {
          window.dispatchEvent(new CustomEvent('selling-plan-selector:plan-selected'));
          
          const bmsmQty = Number(bmsm.value);
          const bmsmDisplays = document.querySelectorAll('[data-bmsm-display]');
          
          bmsmDisplays.forEach(el => {
            el.innerText = `${bmsmQty} Tub${bmsmQty > 1 ? `s` :``}`;
          });
        });
      });
    }

    productSwap(id) {
      const tpl = document.querySelector(`template[data-selector="${id}"]`);
      if (!tpl) return;

      const selectorsWrap = this.closest('[data-selling-plan-selectors]') || this;
      const wasOnetime = !!this.querySelector('input[value="onetime"]')?.checked;

      const frag = tpl.content.cloneNode(true);
      const newOnetime = frag.querySelector('input[value="onetime"]');
      const newSubscribe = frag.querySelector('input[value="subscribe"]');

      if (newOnetime && newSubscribe) {
        newOnetime.checked = wasOnetime;
        newSubscribe.checked = !wasOnetime;

        if (!wasOnetime) {
          const sellingPlanSelect = frag.querySelector('[name="selling_plan"]');
          const thisSellingPlanSelect = this.querySelector('[name="selling_plan"]');
          const targetText = thisSellingPlanSelect.options[thisSellingPlanSelect.selectedIndex]?.innerText?.trim();
          const match = targetText && sellingPlanSelect
            ? [...sellingPlanSelect.options].find(o => o.innerText.trim() === targetText)
            : null;
          if (match) sellingPlanSelect.value = match.value;
        }
      }

      selectorsWrap.replaceChildren(frag);

      if (!wasOnetime) {
        const qtySelector = document.querySelector('input[type="radio"][name="quantity"][value="1"]');
        if (qtySelector) qtySelector.checked = true;
      }

      this.syncFormInputs();
    }

    syncFormInputs() {
      const sellingPlanSelect = this.querySelector('[name="selling_plan"]');
      const onetimeSelect = this.querySelector('input[value="onetime"]');
      const subscribeSelect = this.querySelector('input[value="subscribe"]');
      const qtySelector = document.querySelector('input[type="radio"][value="1"][name="quantity"]');

      if (onetimeSelect?.checked && sellingPlanSelect) {
        sellingPlanSelect.disabled = true;
        if (subscribeSelect) subscribeSelect.checked = false;
        onetimeSelect.checked = true;
        const bmsmDisplays = document.querySelectorAll('[data-bmsm-display]');
          
        bmsmDisplays.forEach(el => {
          el.innerText = `1 Tub`;
        });
      } else {
        if (subscribeSelect) subscribeSelect.checked = true;
        if (onetimeSelect) onetimeSelect.checked = false;
        if (sellingPlanSelect) sellingPlanSelect.disabled = false;
        if (qtySelector) {
          qtySelector.checked = true;
        }
      }
      
      window.dispatchEvent(new CustomEvent('selling-plan-selector:plan-selected'));
    }
  }

  customElements.define('selling-plan-selector', SellingPlanSelector);
}
